import moment from "moment";
import React, { useEffect, useState } from "react";
import Functions from "../../../Helpers/Functions";
import CourseProposalRepository from "../../../Repositories/CourseProposalRepository";
import { useSelector } from "react-redux";

export type TeachrCardProps = {
  openProposal: {
    id: number | string;
    teacherName: string;
    teachrId: number;
    teacherId?: number;
    message?: string;
    description?: string;
    startDatetime: string;
    endDatetime: string;
    priceRate: number;
    finalTotal: number;
    isAccepted: boolean;
    isRefused: boolean;
  };
  onRefuse?: (proposalId: number) => void;
  onAccept?: (proposalId: number) => void;
  duration?: number;
  activeTab?: string;
};

const avis = "⭐️⭐️⭐️⭐️⭐️ Avis";

const TeachrCard: React.FC<TeachrCardProps> = ({ openProposal, onRefuse , onAccept, duration, activeTab}) => {
  const [message, setMessage] = useState(false);
  const [description, setDescription] = useState(false);
  const [loading, setLoading] = useState(false);
  const clientId = useSelector(
    (state: any) => state.user.currentUser?.client.id
  );
  const [proposalState, setProposalState] = useState(openProposal);

  useEffect(() => {
    if (openProposal.message) setMessage(true);
    if (openProposal.description) setDescription(true);
  }, [openProposal]);

  const handleRefuse = async () => {
    if (!proposalState || !clientId) return;

    try {
      setLoading(true);
      const fullProposal =
        await CourseProposalRepository.fetchCourseProposalById(
          Number(proposalState.id)
        );
      await CourseProposalRepository.refuseCourseProposal({
        ...fullProposal,
        isRefused: true,
      });

      // update parent table
      onRefuse?.(Number(proposalState.id));

      setProposalState({
        ...proposalState,
        isRefused: true,
        isAccepted: false,
      });
    } catch (error) {
      console.error("Error refusing proposal:", error);
    } finally {
      setLoading(false); 
    }
  };

  const handleAccept = async () => {
    if (!proposalState || !clientId) return;

    // Close dialog and refetch immediately
    onAccept?.(Number(proposalState.id));

    try {
      setLoading(true);
      await CourseProposalRepository.acceptCourseProposal(
        Number(clientId),
        Number(proposalState.id)
      );
      // setProposalState({ ...proposalState, isAccepted: true }); // optional for now
    } catch (error) {
      console.error("Error accepting proposal:", error);
    } finally {
      setLoading(false);
    }
  };
  
  const totalPrice = (openProposal.priceRate * (duration ?? 1)).toFixed(2);
  return (
    <div className="bg-[#ffffff] p-12">
      <div className="flex gap-2 w-full mx-auto">
        <div className="bg-profilePic h-20 w-20 bg-cover" />
        <div>
          <p className="text-[#0456A4] font-bold text-2xl">
            {openProposal.teacherName}
          </p>
          <small>{avis}</small>
          <div>
            {Functions.renderTeachrHours(
              moment
                .duration(
                  moment(openProposal.endDatetime).diff(
                    moment(openProposal.startDatetime)
                  )
                )
                .asHours()
            )}
          </div>
        </div>
      </div>

      <div className="flex flex-col my-4 gap-2">
        <p className="text-[#0456A4] font-bold">
          Tarif horaire: {openProposal.priceRate} €
        </p>
        <p className="text-[#0456A4] font-bold">
          {/* Prix total: {openProposal.finalTotal.toFixed(2)} € */}
          Prix total : {totalPrice} €
        </p>
      </div>

      {message && (
        <p>
          <span className="font-bold text-[#0456A4]">Message: </span>{" "}
          {openProposal.message}
        </p>
      )}

      {description && (
        <p>
          <span className="font-bold text-[#0456A4]">Description: </span>{" "}
          {openProposal.description}
        </p>
      )}

      {proposalState.isRefused && (
        <p className="inline-block text-red-500 mb-2 px-3 py-1 bg-red-100 rounded">
          Cours Refusé
        </p>
      )}

      {activeTab !== "historic" && activeTab !== "taken" && ( <div className="flex gap-2 mt-4">
        <button
          className="disabled:opacity-30 p-1 rounded-full text-third border-third hover:bg-third hover:text-white border-2 w-full"
          onClick={handleRefuse}
          disabled={proposalState.isRefused || !clientId || loading}
        >
          {loading ? (
            <span className="animate-spin inline-block w-4 h-4 border-2 border-t-transparent rounded-full mr-2"></span>
          ) : null}
          {loading ? "Refus en cours..." : "NON, MERCI"}
        </button>

        <button
          className="disabled:opacity-30 p-1 rounded-full text-white bg-[#0154A3] border-2 w-full"
          onClick={handleAccept}
          disabled={proposalState.isRefused || !clientId || loading}
        >
          {loading && !proposalState.isAccepted ? (
            <span className="animate-spin inline-block w-4 h-4 border-2 border-t-transparent rounded-full mr-2"></span>
          ) : null}
          {proposalState.isAccepted ? "Accepté" : "ACCEPTER"}
        </button>
      </div>)} 

      {/* <div className="flex gap-2 mt-4">
        <button
          className="disabled:opacity-30 p-1 rounded-full text-third border-third hover:bg-third hover:text-white border-2 w-full"
          onClick={handleRefuse}
          disabled={proposalState.isRefused || !clientId || loading}
        >
          {loading ? (
            <span className="animate-spin inline-block w-4 h-4 border-2 border-t-transparent rounded-full mr-2"></span>
          ) : null}
          {loading ? "Refus en cours..." : "NON, MERCI"}
        </button>

        <button
          className="disabled:opacity-30 p-1 rounded-full text-white bg-[#0154A3] border-2 w-full"
          onClick={handleAccept}
          disabled={proposalState.isRefused || !clientId || loading}
        >
          {loading && !proposalState.isAccepted ? (
            <span className="animate-spin inline-block w-4 h-4 border-2 border-t-transparent rounded-full mr-2"></span>
          ) : null}
          {proposalState.isAccepted ? "Accepté" : "ACCEPTER"}
        </button>
      </div> */}
    </div>
  );
};

export default TeachrCard;